"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetCat = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PetCat = function PetCat(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.997 14.647c-.06.535-.81 1.726-1.979 1.785a85.38 85.38 0 01-1.828.064c-.78 1.856-.055 3.174-.607 5.763-.582 2.728-1.649 4.59-1.649 4.59l.582 4.849s1.512-.03 1.296 1.302h-2.68l-1.29-4.231a4.26 4.26 0 00.041-.57c0-1.576-.966-2.732-1.725-3.396l-.831-.596-.287.415-.284.415s2.1 1.185 2.1 3.162c0 1.976-1.738 3.018-1.738 3.018C23.783 31.36 23.421 33 23.421 33h-10.35s-.025-.05-.065-.138c-2.119-.114-4.504-1.227-5.514-3.784-1.223-3.1.102-5.89 1.07-7.927.164-.344.32-.674.459-.99.986-2.26.893-3.4.642-3.959-.171-.383-.48-.637-.968-.8l.49-1.45c.902.3 1.536.848 1.886 1.627.548 1.22.334 2.967-.635 5.19-.145.33-.309.675-.48 1.034-.941 1.984-2.01 4.23-1.029 6.716.679 1.717 2.11 2.493 3.455 2.734-.797-2.386-1.748-6.761.398-10.204 3.113-4.994 8.976-4.498 8.976-4.498S22.716 9.797 28.56 7l.45 1.19 1.349-.744v2.886s1.08.625 1.469 1.905c.39 1.279 1.229 1.874 1.169 2.41z",
    fill: "#97BA1E"
  }));
};

exports.PetCat = PetCat;
var _default = PetCat;
exports.default = _default;